var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animate-push-on-panel md_transform transition duration-200",class:{'md_translate-x-2x12': _vm.panelIsOpen}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }